@if (pwa.promptVisible()) {
  <aside class="lem-install-card" role="dialog" aria-modal="false" aria-labelledby="lem-install-title">
    <button type="button" class="lem-install-card__close" (click)="close()" [attr.aria-label]="'Fermer' | lemTranslate">
      <lem-icon name="close" [size]="18" />
    </button>

    <span class="lem-install-card__icon">
      <lem-icon [name]="isMobile() ? 'smartphone' : 'monitor'" [size]="25" />
    </span>

    <div class="lem-install-card__copy">
      <span class="lem-install-card__eyebrow">{{ 'Accès rapide à LEM' | lemTranslate }}</span>
      <h2 id="lem-install-title">{{ 'Installer LEM sur cet appareil' | lemTranslate }}</h2>
      <p>
        {{ 'Retrouvez LEM depuis votre écran d’accueil ou votre bureau, avec un accès plus rapide et le mode hors connexion.' | lemTranslate }}
      </p>
    </div>

    @if (showIosHelp()) {
      <div class="lem-install-card__ios">
        <strong>{{ 'Sur iPhone ou iPad' | lemTranslate }}</strong>
        <ol>
          <li>{{ 'Touchez le bouton Partager dans Safari.' | lemTranslate }}</li>
          <li>{{ 'Choisissez « Sur l’écran d’accueil ».' | lemTranslate }}</li>
          <li>{{ 'Validez avec « Ajouter ».' | lemTranslate }}</li>
        </ol>
      </div>
    }

    <div class="lem-install-card__actions">
      <button type="button" class="lem-btn lem-btn--primary" (click)="install()" [disabled]="installing()">
        <lem-icon name="download" [size]="17" />
        {{ (pwa.mode() === 'ios' ? 'Voir comment installer' : installing() ? 'Installation…' : 'Installer maintenant') | lemTranslate }}
      </button>
      <button type="button" class="lem-btn lem-btn--secondary" (click)="pwa.remindLater()">
        {{ 'Me le rappeler plus tard' | lemTranslate }}
      </button>
    </div>
  </aside>
}
